// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__hzCG7","box":"Navbar_box__b1yMA","mobile_btn":"Navbar_mobile_btn__bNHSk"};